import { z } from 'zod';
import { filtersValidator } from '@/features/filters';
import {
  DateScale,
  serializedDateRangeValueObjectValidator,
} from '@/shared/types';

export const dataConfigValidator = z.object({
  cohortDateScale: z.nativeEnum(DateScale),
  cohortDateRange: serializedDateRangeValueObjectValidator,
  revenueDateScale: z.nativeEnum(DateScale),
  revenueDateRange: serializedDateRangeValueObjectValidator,
  probabilisticAttribution: z.boolean(),
  dimension: z.string(),
  excludedSplitOptions: z.array(z.string()),
  metric: z.string(),
  showRelativeValues: z.boolean(),
  filters: filtersValidator,
});

export type DataConfig = z.infer<typeof dataConfigValidator>;
